import mailVistaLogo from "@/assets/icons/logo-mailvista.svg";
import firstConnectionBackground from "@/assets/images/first-connection-background.svg";
import loadingCircles from "@/assets/lotties/loading_circles.json";
import LogoutEscapeLink from "@/components/LogoutEscapeLink";
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";

const FirstConnectionPage = () => {
    const { t } = useTranslation();

    return (
        <div
            className="flex min-h-screen w-full flex-col px-6 pb-8 pt-10"
            style={{
                backgroundImage: `url(${firstConnectionBackground})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
            }}
        >
            <div className="flex w-full flex-col items-center">
                <img
                    alt="Mailvista"
                    className="h-8 w-auto max-w-[200px] object-contain object-center"
                    src={mailVistaLogo}
                />
            </div>

            <div className="relative flex flex-1 px-4">
                <div className="absolute left-1/2 top-[12vh] flex w-full max-w-md -translate-x-1/2 flex-col items-center text-center">
                    <div className="mb-4 flex h-[200px] w-[200px] items-center justify-center">
                        <Lottie
                            animationData={loadingCircles}
                            className="h-full w-full"
                            loop
                        />
                    </div>
                    <h1 className="mb-6 max-w-md font-body text-[21px] font-bold text-black">
                        {t("firstConnection.title")}
                    </h1>
                    <p className="max-w-md font-body text-[18px] font-medium text-[#334155]">
                        {t("firstConnection.subtitle")}
                    </p>
                </div>
            </div>

            <div className="flex w-full flex-col items-center gap-4">
                <p className="max-w-md text-center font-body text-[16px] font-light text-black">
                    {t("firstConnection.footnote")}
                </p>
                <LogoutEscapeLink variant="pillLight" />
            </div>
        </div>
    );
};

export default FirstConnectionPage;
